import React, { useState } from "react";
import BlogInfography from "./components/BlogInfography";
import { Box, Modal, useMediaQuery } from "@mui/material";
import Share from "@common/components/Share";

import Impact from "./components/Impact";
import FeatureInfo from "./components/FeatureInfo";
import { useNavigate, useParams } from "react-router-dom";
import CloudinaryAdvancedImage from "@common/utils/CloudinaryAdvancedImage";
import { processJSXContent } from "@common/utils/blogHyperlinks";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

function BlogDetails() {
  const [shareOptionModal, setShareOptionModal] = useState(false);
  const { slug } = useParams();
  const navigate = useNavigate();
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  // console.log('slug', slug);

  const isFirstBlog =
    slug === "how-sustainable-fabrics-are-shaping-the-future-of-home-decor";

  const handleOpenShareOptionModal = () => {
    setShareOptionModal(true);
  };

  const handleCloseShareOptionModal = () => {
    setShareOptionModal(false);
  };

  const [blog] = useState({
    id: 5,
    slug: "eco-friendly-fabrics",
    heading: "Eco-Friendly Fabrics",
    subHeading: "Sustainable Fabrics for a Greener Future",
    thumbnailUrl: "https://example.com/images/eco-fabrics.jpg",
    publishDate: "2024-06-15T00:00:00.000Z",
    sections: [
      {
        images: [
          {
            url: "https://example.com/images/eco-fabric-1.jpg",
            sequence: 1,
          },
        ],
        content: `Sustainable fabrics like organic cotton, hemp, and recycled polyester are better for the environment...
                Sustainable fabrics like organic cotton, hemp, and recycled polyester are better for the environment,
                Sustainable fabrics like organic cotton, hemp, and recycled polyester are better for the environment,
                Sustainable fabrics like organic cotton, hemp, and recycled polyester are better for the environment,
                Sustainable fabrics like organic cotton, hemp, and recycled polyester are better for the environment,
                Sustainable fabrics like organic cotton, hemp, and recycled polyester are better for the environment,
                `,
        heading: "What Are Eco-Friendly Fabrics?",
        section_number: 1,
      },
      {
        images: [
          {
            url: "https://example.com/images/eco-fabric-2.jpg",
            sequence: 1,
          },
        ],
        content:
          "Eco-friendly fabrics reduce waste and pollution, promoting a healthier planet...",
        heading: "Why Choose Sustainable Fabrics?",
        section_number: 2,
      },
      {
        images: [
          {
            url: "https://example.com/images/eco-fabric-labels.jpg",
            sequence: 1,
          },
        ],
        content:
          "Look for certifications like GOTS, OEKO-TEX, and Fair Trade when shopping for fabrics...",
        heading: "How to Identify Sustainable Fabrics",
        section_number: 3,
      },
    ],
    type: "type-5",
    isActive: true,
    createdAt: "2025-03-23T14:40:33.000Z",
    updatedAt: "2025-03-23T14:40:33.000Z",
  });

  // useEffect(() => {
  //     if (id) {
  //         const blogs_data = JSON.parse(localStorage.getItem('blogs_data'));
  //         setBlog(blogs_data.find((blog) => (blog.slug).toLowerCase() === id.toLowerCase()));
  //     }
  // }, [id]);


  const contentWrapperStyles = {
    padding: isDesktop ? "60px 40px 40px 40px" : "20px",
    maxWidth: isDesktop ? "1000px" : "800px",
    margin: "30px auto",
    marginTop: "44px",
    position: "relative",
    zIndex: "1",
  };

  const galleryMaxWidth = isDesktop ? "920px" : "720px";
  const headingFontSize = "1.75rem";
  const paragraphFontSize = "1.125rem";
  const choosingSectionStyles = {
    display: "flex",
    flexDirection: isDesktop ? "row" : "column",
    gap: isDesktop ? "32px" : "24px",
    alignItems: "stretch",
    backgroundColor: "#f8f3ed",
    borderRadius: "24px",
    padding: isDesktop ? "40px" : "20px",
    boxShadow: "0 18px 40px rgba(81, 49, 23, 0.12)",
    transition: "transform 0.3s ease",
  };
  const choosingImagesContainerStyles = {
    flex: isDesktop ? "0 0 48%" : "1 1 auto",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  };
  const choosingImagesGridStyles = {
    display: "grid",
    gridTemplateColumns: isDesktop
      ? "repeat(2, minmax(140px, 1fr))"
      : "repeat(auto-fit, minmax(140px, 1fr))",
    gap: "16px",
  };
  const choosingImageTileStyles = {
    position: "relative",
    borderRadius: "18px",
    overflow: "hidden",
    height: isDesktop ? "320px" : "220px",
    cursor: "pointer",
    boxShadow: "0 16px 36px rgba(81, 49, 23, 0.14)",
  };
  const choosingImageStyles = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  };
  const choosingImageLabelStyles = {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    padding: "12px 16px",
    background:
      "linear-gradient(180deg, rgba(5, 4, 3, 0) 0%, rgba(81, 49, 23, 0.85) 90%)",
    color: "#fff",
    fontWeight: 600,
    fontSize: "0.85rem",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    textAlign: "center",
  };
  const choosingTextContainerStyles = {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "16px",
    backgroundColor: "#ffffff",
    borderRadius: "20px",
    padding: isDesktop ? "32px" : "20px",
    boxShadow: "0 18px 34px rgba(81, 49, 23, 0.08)",
  };
  const choosingParagraphStyles = {
    fontSize: paragraphFontSize,
    lineHeight: 1.7,
    color: "#4c3b2a",
    margin: 0,
    textAlign: "left",
  };
  const choosingCtaStyles = {
    alignSelf: "flex-start",
    padding: "12px 28px",
    backgroundColor: "#513117",
    color: "#ffffff",
    borderRadius: "999px",
    border: "none",
    fontWeight: 600,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    fontSize: "0.85rem",
    cursor: "pointer",
  };
  const choosingSectionImages = [
    {
      id: "budget-blackout-collection",
      title: "Budget Blackout Collection",
      href: "/collection-detail/Budget-Blackout".toLowerCase(),
    },
    {
      id: "_A1_4258",
      title: "Dim-Out Styling Inspiration",
      href: "/collection-detail/daydream".toLowerCase(),
    },
  ];

  // how-sustainable-fabrics-are-shaping-the-future-of-home-decor

  return (
    <>
      {isFirstBlog ? (
        <div className="lyt-blog-details">
          <div className="lyt-blog-details__head-wrap">
            <button className="lyt-blog-details__back-btn bs-btn bs-btn__btn-icon">
              <span
                className="icon icon-left"
                onClick={() => navigate("/blogs")}
              ></span>
            </button>
            <h1 className="lyt-blog-details__title">Blogs</h1>
          </div>
          <div className="lyt-blog-details__cont-wrap">
            <ul className="lyt-blog-details__cont-list-wrap">
              <li className="lyt-blog-details__cont-list-item">
                <BlogInfography
                  imageTitle="LOCOMOTION - SUSTAINABLE SHEERS"
                  imageUrl="blog"
                  infoTitle="how <span className='bs-blog-infography__info-title--highlight'>sustainable fabrics</span> are shaping the future of home décor"
                  infoDescription="In an era defined by eco-consciousness, sustainability has transcended being a mere trend to become a core life principle. It has evolved into an essential lifestyle choice, fundamentally reshaping the landscape of home décor. Sustainable fabrics now lead the way, responding to the growing demand for materials that are both aesthetically pleasing and environmentally friendly. As designers and homeowners embrace renewable, biodegradable, and responsibly sourced options like Locomotion, Earthen, and Satina collections, modern interiors are evolving to seamlessly blend style with sustainability."
                />
              </li>
              <li className="lyt-blog-details__cont-list-item">
                <div className="lyt-blog-details__col-wrap">
                  <div className="lyt-blog-details__col-item">
                    <Impact />
                  </div>
                  <div className="lyt-blog-details__col-item">
                    <FeatureInfo />
                  </div>
                </div>
              </li>
              <li className="lyt-blog-details__cont-list-item">
                <button
                  className="bs-btn bs-btn__btn-icon-solid"
                  onClick={handleOpenShareOptionModal}
                >
                  <span className="bs-btn__icon icon icon-share"></span>
                  <span className="bs-btn__btn-text">share</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      ) : slug === "wedding-gifting-ideas-for-2026-why-premium-bedding-is-the-new-must-have-gift" ? (
        <div className="lyt-blog-details">
          <div className="lyt-blog-details__head-wrap">
            <button className="lyt-blog-details__back-btn bs-btn bs-btn__btn-icon">
              <span
                className="icon icon-left"
                onClick={() => navigate("/blogs")}
              ></span>
            </button>
            <h1 className="lyt-blog-details__title">Blogs</h1>
          </div>

          <div
            className="lyt-blog-details__banner-wrap"
            style={{ paddingInline: "20px" }}
          >
            <BlogInfography
              imageTitle="Premium Bedding Collection"
              imageUrl="/images/blog/twogift.jpeg"
              infoTitle="WEDDING GIFTING IDEAS FOR 2026: WHY PREMIUM BEDDING IS THE NEW MUST-HAVE GIFT"
              infoDescription={
                "Wedding gifting in India is undergoing a quiet but meaningful shift. While traditional options like crockery, décor accents, and silverware remain popular, modern couples increasingly value gifts that are thoughtful, functional, and long-lasting. As we move into 2026, premium bedding is emerging as one of the most relevant and appreciated wedding gifts combining everyday luxury with emotional value."
              }
              variant={"fullwidth"}
            />
          </div>

          <div
            className="lyt-blog-details__cont-wrap"
            style={contentWrapperStyles}
          >
            {/* Section 1 - Why Bedding Is a Smart Wedding Gift */}
            <div className="blog-section" style={{ marginBottom: "60px" }}>
              <h3
                style={{
                  fontSize: headingFontSize,
                  fontWeight: "bold",
                  marginBottom: "20px",
                  textTransform: "uppercase",
                  color: "#A8795A",
                  letterSpacing: "1px",
                  fontFamily: '"Baskervville", serif',
                }}
              >
                Why Bedding Is a Smart Wedding Gift in 2026
              </h3>

              <p
                style={{
                  fontSize: paragraphFontSize,
                  lineHeight: "1.6",
                  marginBottom: "15px",
                  textAlign: "justify",
                }}
              >
                Today’s couples are setting up homes that reflect comfort, wellness, and conscious living. Unlike decorative gifts that may or may not suit personal taste, bedding becomes part of daily life used, felt, and appreciated every single day.
              </p>
              <div
                style={{
                  fontSize: paragraphFontSize,
                  lineHeight: "1.6",
                  marginBottom: "15px",
                  textAlign: "justify",
                }}
              >
                Key reasons bedding works as a wedding gift:
                <ul style={{ paddingLeft: "20px", marginTop: "10px", listStyle: 'disc' }}>
                  <li>1. Universally useful and size-flexible</li>
                  <li>2. Long lifespan compared to décor accessories</li>
                  <li>3. Associated with comfort, rest, and well-being</li>
                  <li>4. Suitable for both modern and traditional homes</li>
                </ul>
              </div>
              <p
                style={{
                  fontSize: paragraphFontSize,
                  lineHeight: "1.6",
                  marginBottom: "15px",
                  textAlign: "justify",
                }}
              >
                From a design perspective, bedding also sets the tone for the bedroom the most personal space in a home.
              </p>

              <h3
                style={{
                  fontSize: headingFontSize,
                  fontWeight: "bold",
                  marginBottom: "20px",
                  marginTop: "40px",
                  textTransform: "uppercase",
                  color: "#A8795A",
                  letterSpacing: "1px",
                  fontFamily: '"Baskervville", serif',
                }}
              >
                Trend Insight: What Couples Look for in Bedding Gifts Today
              </h3>
              <div
                style={{
                  fontSize: paragraphFontSize,
                  lineHeight: "1.6",
                  marginBottom: "15px",
                  textAlign: "justify",
                }}
              >
                Wedding gifting trends for 2026 show a clear preference for:
                <ol style={{ paddingLeft: "20px", marginTop: "10px", listStyle: 'disc' }}>
                  <li>1. Neutral, timeless colour palettes</li>
                  <li>2. Coordinated bedding sets rather than single pieces</li>
                  <li>3. Premium finishes that feel indulgent but understated</li>
                  <li>4. Thoughtfully curated collections that remove guesswork</li>
                </ol>
                This is where layered bedding concepts and complete look solutions are gaining traction.
              </div>
            </div>

            {/* Section 2 - Luxe Layers */}
            <div className="blog-section" style={{ marginBottom: "60px" }}>
              <h3
                style={{
                  fontSize: headingFontSize,
                  fontWeight: "bold",
                  marginBottom: "20px",
                  textTransform: "uppercase",
                  color: "#A8795A",
                  letterSpacing: "1px",
                  fontFamily: '"Baskervville", serif',
                }}
              >
                Luxe Layers: A Thoughtful Wedding Gifting Choice
              </h3>
              <p
                style={{
                  fontSize: paragraphFontSize,
                  lineHeight: "1.6",
                  marginBottom: "25px",
                  textAlign: "justify",
                }}
                dangerouslySetInnerHTML={processJSXContent(
                  "Layered bedding reflects modern living where comfort meets visual harmony. Instead of gifting individual items, curated sets offer a complete bedroom experience, making them ideal for weddings. The Luxe Layers collection is designed around this very idea bringing together texture, comfort, and coordination in one cohesive story."
                )}
              />

              <div
                style={{
                  textAlign: "center",
                  marginTop: "30px",
                  clear: "both",
                  width: "100%",
                  cursor: "pointer"
                }}
                onClick={() => window.location.href = "/products/collection/luxe-layers"}
              >
                <img src="/images/blog/BD000897_1.png" className="choosing-image__media" style={{
                  width: "100%",
                  maxWidth: galleryMaxWidth,
                  height: "auto",
                  display: "block",
                  margin: "0 auto",
                }} />
                <div
                  style={{
                    backgroundColor: "#513117",
                    color: "white",
                    padding: "8px",
                    textAlign: "center",
                    fontSize: "11px",
                    fontWeight: "bold",
                    maxWidth: galleryMaxWidth,
                    margin: "0 auto",
                    marginTop: "0",
                  }}
                >
                  Luxe Layers Collection
                </div>
              </div>
            </div>

            {/* Section 3 - Comforters */}
            <div className="blog-section" style={{ marginBottom: "60px" }}>
              <h3
                style={{
                  fontSize: headingFontSize,
                  fontWeight: "bold",
                  marginBottom: "20px",
                  textTransform: "uppercase",
                  color: "#A8795A",
                  letterSpacing: "1px",
                  fontFamily: '"Baskervville", serif',
                }}
              >
                Comforters: Practical Luxury Every Couple Appreciates
              </h3>
              <p
                style={{
                  fontSize: paragraphFontSize,
                  lineHeight: "1.6",
                  marginBottom: "25px",
                  textAlign: "justify",
                }}
                dangerouslySetInnerHTML={processJSXContent(
                  "Comforters are often overlooked as wedding gifts, yet they are among the most used bedding essentials. A high-quality comforter offers warmth, breathability, and comfort across seasons making it both a practical and indulgent choice. Why comforters make sense for wedding gifting: Suitable for year-round use in Indian homes, Easy to pair with existing or gifted bed linen, Adds instant comfort and visual softness to bedrooms."
                )}
              />
              <div
                style={{
                  textAlign: "center",
                  marginTop: "30px",
                  clear: "both",
                  width: "100%",
                  cursor: "pointer"
                }}
                onClick={() => window.location.href = "/products/comforters"}
              >
                <img src="/images/blog/BD000148_1.jpg" className="choosing-image__media" style={{
                  width: "100%",
                  maxWidth: galleryMaxWidth,
                  height: "700px",
                  display: "block",
                  margin: "0 auto",
                }} />
                <div
                  style={{
                    backgroundColor: "#513117",
                    color: "white",
                    padding: "8px",
                    textAlign: "center",
                    fontSize: "11px",
                    fontWeight: "bold",
                    maxWidth: galleryMaxWidth,
                    margin: "0 auto",
                    marginTop: "0",
                  }}
                >
                  Comforters Collection
                </div>
              </div>
            </div>

            {/* Section 4 - Bedding Look Book */}
            <div className="blog-section" style={{ marginBottom: "60px" }}>
              <h3
                style={{
                  fontSize: headingFontSize,
                  fontWeight: "bold",
                  marginBottom: "20px",
                  textTransform: "uppercase",
                  color: "#A8795A",
                  letterSpacing: "1px",
                  fontFamily: '"Baskervville", serif',
                }}
              >
                The Bedding Look Book: Gifting with Visual Confidence
              </h3>
              <p
                style={{
                  fontSize: paragraphFontSize,
                  lineHeight: "1.6",
                  marginBottom: "25px",
                  textAlign: "justify",
                }}
                dangerouslySetInnerHTML={processJSXContent(
                  "One of the biggest challenges in wedding gifting is uncertainty Will the couple like it? Will it suit their home? This is where curated look-based selections add immense value. The Bedding Look Book offers pre-styled combinations that help gift-givers choose confidently. It presents bedding as a complete visual concept rather than isolated products."
                )}
              />
              <div
                style={{
                  textAlign: "center",
                  marginTop: "30px",
                  clear: "both",
                  width: "100%",
                  cursor: "pointer"
                }}
                onClick={() => window.location.href = "/products/packagingtype/gift?packagingtypes=gift"}
              >
                <img src="/images/blog/single_gift.jpeg" className="choosing-image__media" style={{
                  width: "100%",
                  maxWidth: galleryMaxWidth,
                  height: "800px",
                  display: "block",
                  objectFit: "cover",
                  margin: "0 auto",
                }} />
                <div
                  style={{
                    backgroundColor: "#513117",
                    color: "white",
                    padding: "8px",
                    textAlign: "center",
                    fontSize: "11px",
                    fontWeight: "bold",
                    maxWidth: galleryMaxWidth,
                    margin: "0 auto",
                    marginTop: "0",
                  }}
                >
                  The Bedding Look Book
                </div>
              </div>
            </div>

            {/* Section 5 - Final Thoughts */}
            <div className="blog-section" style={{ marginBottom: "60px" }}>
              <h3
                style={{
                  fontSize: headingFontSize,
                  fontWeight: "bold",
                  marginBottom: "20px",
                  textTransform: "uppercase",
                  color: "#A8795A",
                  letterSpacing: "1px",
                  fontFamily: '"Baskervville", serif',
                }}
              >
                Final Thoughts: Gifting Comfort Is Gifting Longevity
              </h3>
              <p
                style={{
                  fontSize: paragraphFontSize,
                  lineHeight: "1.6",
                  marginBottom: "15px",
                  textAlign: "justify",
                }}
              >
                In 2026, wedding gifts are no longer about display they’re about daily experience and emotional connection. Bedding fits seamlessly into this mindset, offering comfort, design value, and long-term use.
              </p>
              <p
                style={{
                  fontSize: paragraphFontSize,
                  lineHeight: "1.6",
                  marginBottom: "15px",
                  textAlign: "justify",
                }}
              >
                For architects, interior designers, and families curating premium wedding gifts, bedding represents a future-ready choice one that aligns with modern living, conscious consumption, and timeless design. When thoughtfully chosen, bedding doesn’t just furnish a home it becomes part of the couple’s everyday story.
              </p>
            </div>


            {/* Share button */}
            <div
              style={{
                textAlign: "left",
                marginTop: "30px",
                marginBottom: "20px",
              }}
            >
              <button
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "13.2px",
                  color: "#666",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
                onClick={handleOpenShareOptionModal}
              >
                <span style={{ fontSize: "14px" }}>🔗</span>
                Share
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="lyt-blog-details">
          <div className="lyt-blog-details__head-wrap">
            <button className="lyt-blog-details__back-btn bs-btn bs-btn__btn-icon">
              <span
                className="icon icon-left"
                onClick={() => navigate("/blogs")}
              ></span>
            </button>
            <h1 className="lyt-blog-details__title">Blogs</h1>
          </div>

          {/* Main Blog Header Section */}
          <div
            className="lyt-blog-details__banner-wrap"
            style={{ paddingInline: "20px" }}
          >
            <BlogInfography
              imageTitle="Eco Dim-out Texture Collection"
              imageUrl="blog"
              infoTitle="THE ULTIMATE GUIDE TO BLACKOUT & DIM-OUT CURTAINS WITH SANSAAR"
              infoDescription={
                "In the realm of interior design, light control plays a vital role in shaping a room’s atmosphere and functionality. Whether it’s managing the intensity of sunlight, enhancing privacy, or ensuring a restful environment, the right window treatment can make all the difference. Dim-out and blackout curtains are no longer merely practical additions—they are integral elements in creating a refined, harmonious living space. Sansaar, a leading name in premium sustainable home décor, offers a range of curtains that combine luxurious textures with advanced light control, while also embracing eco-conscious production practices"
              }
              variant={"fullwidth"}
            />
          </div>

          <div
            className="lyt-blog-details__cont-wrap"
            style={contentWrapperStyles}
          >
            {/* Section 1 - DIM-OUT CURTAINS */}
            <div className="blog-section" style={{ marginBottom: "60px" }}>
              <h3
                style={{
                  fontSize: headingFontSize,
                  fontWeight: "bold",
                  marginBottom: "20px",
                  textTransform: "uppercase",
                  color: "#A8795A",
                  letterSpacing: "1px",
                  fontFamily: '"Baskervville", serif',
                }}
              >
                DIM-OUT CURTAINS: SOFT, ELEGANT LIGHT CONTROL
              </h3>

              <p
                style={{
                  fontSize: paragraphFontSize,
                  lineHeight: "1.6",
                  marginBottom: "15px",
                  textAlign: "justify",
                }}
              >
                Dim-out curtains are designed to offer a balanced reduction in
                sunlight, perfect for spaces where you want to soften the light
                without eliminating it entirely. These fabrics gently diffuse
                natural light, creating a relaxed yet subtle atmosphere that
                maintains the sense of openness in a room, ideal for living
                rooms, kitchens, or home offices where natural light is desired
                but privacy and glare reduction are also important.
              </p>

              <p
                style={{
                  fontSize: paragraphFontSize,
                  lineHeight: "1.6",
                  marginBottom: "15px",
                  textAlign: "justify",
                }}
                dangerouslySetInnerHTML={processJSXContent(
                  "Sansaar's Eco Dimout Textures and Daydream collections are a testament to the elegance of beautiful textures and neutral colours thoughtfully designed to complement any interior style. These collections offer a soft yet thorough screening, a soothing after-work preserving privacy and minimizing glare. Whether you're seeking the luxurious and statement making appeal of textured fabrics or any lightness of Daydream fabric, these distinct options bring understated sophistication to any room."
                )}
              />

              <p
                style={{
                  fontSize: paragraphFontSize,
                  lineHeight: "1.6",
                  marginBottom: "25px",
                  textAlign: "justify",
                }}
                dangerouslySetInnerHTML={processJSXContent(
                  "Sustainability is at the core of Sansaar's design philosophy, and our Eco Dimout Textures Collections are no exception. Made from eco-friendly materials, it provides a perfect example of how luxury and environmental responsibility can coexist."
                )}
              />

              {/* Daydream collection gallery */}
              <div
                style={{
                  marginTop: "30px",
                  clear: "both",
                  maxWidth: galleryMaxWidth,
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "18px",
                    flexWrap: "wrap",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      flex: "2 1 320px",
                      minWidth: "260px",
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        overflow: "hidden",
                        height: "320px",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        (window.location.href = "/collection-detail/daydream")
                      }
                    >
                      <CloudinaryAdvancedImage
                        imagePublicId="_A1_4255"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          display: "block",
                        }}
                      />
                    </div>
                    <div
                      style={{
                        padding: "6px",
                        fontSize: "12px",
                        fontWeight: "600",
                        color: "white",
                        backgroundColor: "#513117",
                        textAlign: "center",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        (window.location.href = "/collection-detail/daydream")
                      }
                    >
                      Daydream Collection
                    </div>
                  </div>

                  <div
                    style={{
                      flex: "1 1 220px",
                      minWidth: "220px",
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        overflow: "hidden",
                        height: "350px",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        (window.location.href = "/collection-detail/daydream")
                      }
                    >
                      <CloudinaryAdvancedImage
                        imagePublicId="_A1_4258"
                        type="square-collection-thumbnail"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          display: "block",
                        }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 2 - BLACKOUT CURTAINS */}
            <div className="blog-section" style={{ marginBottom: "40px" }}>
              <h3
                style={{
                  fontSize: headingFontSize,
                  fontWeight: "bold",
                  marginBottom: "20px",
                  textTransform: "uppercase",
                  color: "#A8795A",
                  letterSpacing: "1px",
                  fontFamily: '"Baskervville", serif',
                }}
              >
                BLACKOUT CURTAINS: TOTAL DARKNESS AND UNRIVALED COMFORT
              </h3>

              <p
                style={{
                  fontSize: paragraphFontSize,
                  lineHeight: "1.6",
                  marginBottom: "15px",
                  textAlign: "justify",
                }}
              >
                For rooms that require complete darkness, our blackout curtains
                deliver unparalleled light control. Perfect for shift workers,
                light-sensitive sleepers, or anyone who values total privacy,
                these curtains block virtually all incoming light. The dense
                weave and specialized construction ensure that even the
                brightest daylight won't disturb your rest or interfere with
                your daily activities.
              </p>

              <p
                style={{
                  fontSize: paragraphFontSize,
                  lineHeight: "1.6",
                  marginBottom: "25px",
                  textAlign: "justify",
                }}
                dangerouslySetInnerHTML={processJSXContent(
                  "Sansaar's Knockout and Budget Blackout Collections bring a sustainable edge to blackout solutions. The Knockout Collection stands out for its woven construction, a unique alternative to traditionally coated blackouts, making it a truly eco-conscious choice that still delivers 100% light blockage with a luxurious feel. Meanwhile, Budget Blackout is crafted from eco-friendly fabrics that minimize environmental impact while offering effective blackout performance. Together, these collections ensure total privacy and comfort with a commitment to sustainability, giving you functional yet conscientious choices for complete darkness."
                )}
              />

              {/* Full width image */}
              <div
                style={{
                  textAlign: "center",
                  marginTop: "30px",
                  clear: "both",
                  width: "100%",
                  cursor: "pointer"
                }}
                onClick={() => window.location.href = "/collection-detail/knockout"}
              >
                <CloudinaryAdvancedImage imagePublicId="knockout-collection" type="square-collection-thumbnail" className="choosing-image__media" style={{
                  width: "100%",
                  maxWidth: galleryMaxWidth,
                  height: "auto",
                  display: "block",
                  margin: "0 auto",
                }} />
                <div
                  style={{
                    backgroundColor: "#513117",
                    color: "white",
                    padding: "8px",
                    textAlign: "center",
                    fontSize: "11px",
                    fontWeight: "bold",
                    maxWidth: galleryMaxWidth,
                    margin: "0 auto",
                    marginTop: "0",
                  }}
                >
                  Knockout Collection
                </div>
              </div>
            </div>

            {/* Section 3 - CHOOSING YOUR PERFECT FIT */}
            <div
              className="blog-section"
              style={{ marginBottom: "40px", marginTop: "60px" }}
            >
              <h3
                style={{
                  fontSize: headingFontSize,
                  fontWeight: "bold",
                  marginBottom: "20px",
                  textTransform: "uppercase",
                  color: "#A8795A",
                  letterSpacing: "1px",
                  fontFamily: '"Baskervville", serif',
                }}
              >
                CHOOSING YOUR PERFECT FIT WITH SANSAAR
              </h3>

              <div
                className="choosing-section-container"
                onClick={() =>
                  (window.location.href = "/collection-detail/Budget-Blackout")
                }
              >
                <div className="choosing-images-container">
                  <div className="choosing-image choosing-image--primary">
                    <CloudinaryAdvancedImage imagePublicId="budget-blackout-collection" type="square-collection-thumbnail" className="choosing-image__media" style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "left center",
                    }} />
                  </div>
                  <div className="choosing-image choosing-image--secondary">
                    <CloudinaryAdvancedImage imagePublicId="budget-blackout-collection" type="square-collection-thumbnail" className="choosing-image__media" style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "right center",
                    }} />
                  </div>
                  <div className="choosing-collection-label">
                    Budget Blackout Collection
                  </div>
                </div>

                <div className="choosing-text-container">
                  <div className="choosing-text-card">
                    <p
                      dangerouslySetInnerHTML={processJSXContent(
                        "With Sansaar's diverse collections like Daydream, Knockout, Budget Blackout, and Eco Dimout Textures, there's a window treatment for every need and aesthetic. Dim-out and blackout curtains are more than functional solutions; they're design elements that enhance the look and feel of your space. And with Sansaar's dedication to eco-friendly practices, choosing these collections means you're making a sustainable choice without sacrificing luxury."
                      )}
                    />
                  </div>
                </div>
              </div>

              <style jsx>{`
                .choosing-section-container {
                  display: flex;
                  gap: 32px;
                  align-items: stretch;
                  cursor: pointer;
                }

                .choosing-images-container {
                  position: relative;
                  display: flex;
                  flex: 0 0 48%;
                  gap: 14px;
                  min-width: 260px;
                }

                .choosing-image {
                  flex: 1;
                  overflow: hidden;
                  aspect-ratio: 3 / 4;
                }

                .choosing-image__media {
                  width: 100%;
                  height: 100%;
                  display: block;
                }

                .choosing-collection-label {
                  position: absolute;
                  bottom: 26px;
                  left: 50%;
                  transform: translateX(-50%);
                  background-color: #f3efe7;
                  color: #513117;
                  padding: 10px 22px;
                  font-size: 13px;
                  letter-spacing: 0.4px;
                  font-weight: 600;
                  box-shadow: 0 12px 36px rgba(81, 49, 23, 0.18);
                  text-align: center;
                }

                .choosing-text-container {
                  flex: 1;
                  display: flex;
                  align-items: center;
                }

                .choosing-text-card {
                  width: 100%;
                  height: 100%;
                  background-color: #f3efe7;
                  padding: 32px;
                  color: #513117;
                  font-size: 18.5px;
                  line-height: 1.85;
                  box-shadow: 0 18px 45px rgba(81, 49, 23, 0.12);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                }

                .choosing-text-card p {
                  margin: 0;
                  text-align: justify;
                }

                @media (max-width: 1024px) {
                  .choosing-section-container {
                    gap: 24px;
                  }

                  .choosing-images-container {
                    flex: 1;
                  }
                }

                @media (max-width: 768px) {
                  .choosing-section-container {
                    flex-direction: column !important;
                  }

                  .choosing-images-container {
                    flex: 1 !important;
                    width: 100% !important;
                  }

                  .choosing-text-container {
                    margin-top: 20px;
                  }
                }

                @media (max-width: 480px) {
                  .choosing-section-container {
                    gap: 18px;
                  }

                  .choosing-images-container {
                    flex-direction: column;
                  }

                  .choosing-collection-label {
                    position: static;
                    transform: none;
                    margin-top: 12px;
                    text-align: center;
                    box-shadow: none;
                  }

                  .choosing-text-card {
                    padding: 20px;
                  }
                }
              `}</style>
            </div>

            {/* Share button */}
            <div
              style={{
                textAlign: "left",
                marginTop: "30px",
                marginBottom: "20px",
              }}
            >
              <button
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "13.2px",
                  color: "#666",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
                onClick={handleOpenShareOptionModal}
              >
                <span style={{ fontSize: "14px" }}>🔗</span>
                Share
              </button>
            </div>
          </div>
        </div>
      )}
      <Modal
        open={shareOptionModal}
        onClose={handleCloseShareOptionModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="bs-modal bs-modal--typ-sm"
      >
        <Box className="bs-modal__wrapper" sx={style}>
          <div className="bs-modal__content">
            <button
              className="bs-modal__close"
              onClick={handleCloseShareOptionModal}
            >
              <span className="icon icon-simple-close"></span>
            </button>
            <Share name="LOCOMOTION - SUSTAINABLE SHEERS" />
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default BlogDetails;
